export default {
  navbar: {
    colour: "#4F5C72",
  },
};
